<template>
  <div :class="iconClass" :style="{ width: size + 'px', height: size + 'px', marginRight: '0.3rem' }">
    <slot>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12.424 3.33594C13.3445 3.33594 14.091 4.08246 14.091 5.00293V15.0029C14.0908 15.9233 13.3444 16.6689 12.424 16.6689H7.57536C6.65521 16.6687 5.90952 15.9231 5.90934 15.0029V5.00293C5.90934 4.08262 6.65511 3.3362 7.57536 3.33594H12.424ZM3.02262 4.16895C3.75887 4.16895 4.35639 4.76576 4.35661 5.50195V14.502C4.35661 15.2383 3.759 15.8359 3.02262 15.8359C2.83875 15.8357 2.68962 15.6859 2.68962 15.502V4.50195C2.68983 4.31821 2.83889 4.16921 3.02262 4.16895ZM16.9777 4.16895C17.1616 4.16921 17.3107 4.31802 17.3107 4.50195V15.502C17.3107 15.6859 17.1616 15.8347 16.9777 15.835C16.2413 15.835 15.6437 15.2383 15.6437 14.502V5.50195C15.6437 4.76557 16.2413 4.16895 16.9777 4.16895Z"
          fill="currentColor"
        />
      </svg>
    </slot>
  </div>
</template>

<script>
  export default {
    name: 'IconLead',
    props: {
      iconClass: {
        type: String,
        default: '',
      },

      size: {
        type: [Number, String],
        default: '',
      },
    },
  };
</script>

<style scoped>
  /* You can add any additional styles here */
</style>
